import { useState, useCallback } from 'react';
import { message } from 'antd';
import { pw9314Api, QueryParams, LeaveSummaryRow, LeaveTypeInfo } from '../../../services/pw9314Api';

export function usePW9314Query() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<LeaveSummaryRow[]>([]);
  const [leaveTypes, setLeaveTypes] = useState<LeaveTypeInfo[]>([]);
  const [queried, setQueried] = useState(false);
  const [noData, setNoData] = useState(false);

  const runQuery = useCallback(async (params: QueryParams) => {
    setLoading(true);
    setQueried(false);
    setNoData(false);
    try {
      const resp = await pw9314Api.query(params);
      setLeaveTypes(resp.leave_types || []);
      if (resp.data && resp.data.length > 0) {
        setData(resp.data);
        setNoData(false);
      } else {
        setData([]);
        setNoData(true);
        message.info(resp.message || '查無此資料!');
      }
      setQueried(true);
    } catch {
      message.error('查詢失敗，請稍後再試');
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setData([]);
    setLeaveTypes([]);
    setQueried(false);
    setNoData(false);
  }, []);

  return { loading, data, leaveTypes, queried, noData, runQuery, reset };
}
